module.exports = __webpack_public_path__ + "../resources/img/ic-re-hide-bg-default.c83739ad.svg";